export const FILES_GALLERY_REMOVE_FILE_BTN_QA_NAME = 'filesGalleryRemoveFileBtn'
